module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TG-e7d6dbfc7ae07c40c6eee25c6d4d921f.png";